import React from 'react'
import GlideLock from './GlideLock'
import GlideDelete from './GlideDelete'
import './Glide.css'

export default function Glide({
  showLock,
  showDelete=false,
  unlocker = () => {},
  deleter = () => {}
}) {

  return (
    <div className={`glide ${showLock ? 'showGlider': ''}`}>
      <div className='glideRow'>
        {showDelete && <GlideDelete deleter={deleter}/>}
        {!showDelete && <div></div>}
        <GlideLock unlocker={unlocker}/>
      </div>
    </div>
  )
}
